import React from 'react'
import { observer } from 'mobx-react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetTitle,
} from 'components/ModalSheet'
import { Form, FormRow, TextAreaContainer } from 'components/inputs'
import Button from 'components/Button'
import NotesDialogViewModel from './NotesDialogViewModel'

interface NotesDialogProps {
  vm: NotesDialogViewModel
}

export default observer(function NotesDialog({ vm }: NotesDialogProps) {
  return (
    <ModalSheet
      showing={vm.showing}
      onRequestClose={vm.submit.pending ? undefined : vm.close}
    >
      <ModalSheetHeader bordered withCloseButton>
        <ModalSheetTitle>Notes</ModalSheetTitle>
      </ModalSheetHeader>
      <ModalSheetContent>
        <ModalSheetContentBlock expanded>
          <Form>
            <FormRow>
              <TextAreaContainer
                rows={8}
                model={vm}
                field="text"
                name="text"
                placeholder="Add some instructions or notes here"
                minLength={vm.fieldLengths.text.min}
                maxLength={vm.fieldLengths.text.max}
                error={vm.validation.getError('text')}
                status={vm.validation.getError('text') ? 'danger' : 'default'}
                data-test="provide-notes-text"
              />
            </FormRow>
          </Form>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            type="primary"
            data-test="provide-notes-submit-button"
            onClick={vm.submit}
            loading={vm.submit.pending}
            disabled={vm.submit.pending}
          >
            Save
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
